import {onReady} from "../../../../modules/vegas/js/util";
import {Tab} from "../../dependencies/bootstrap";

/**
 * Go to Tabs
 * @target
 */
function initTabs() {
	[...document.querySelectorAll('[data-toggle="go-to-tab"]')].forEach(trigger => {
		trigger.addEventListener('click', (event) => {
			event.preventDefault();
			let target = trigger.dataset.target;
			if (!target) return;

			let triggerEl = document.getElementById(target);
			if (!triggerEl) return;

			Tab.getOrCreateInstance(triggerEl).show();

			document.getElementById('tabs-product-info').scrollIntoView();
		})
	})
}

onReady(initTabs);
